export default __webpack_public_path__ + "static/media/name-Icon.482cc727.svg";